import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Cifelseif(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
 <title>If else if in c tutorial For Beginners</title>
 <meta name="description" content="if else if in c tutorial for beginners.If else if is used more than two options CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,if else,if,else if,c programming tutorial for beginners,learn code in free,if else statementlearn code in free online" />
 <link rel="canonical" href="https://www.codeexampler.com/c-if-else-if" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">If else if in c</h1>
    <div className="first">
        <a href="/c-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-switch">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


<h2 className='headings'>The syntax for if-else-if in C:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-6">if </span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-10">conditon</span>
                <span className="qwerty-4">) </span>
            {"\n"}
                <span className="qwerty-4" >&#123; </span>
            {"\n"}
                  <span className="qwerty-3"> statement</span>
                  <span className="qwerty-4">;</span>
                  {"\n"}
                <span className="qwerty-4" >&#125;</span>       
            {"\n"}            
               <span className="qwerty-6">else if </span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-10">conditon</span>
                <span className="qwerty-4">) </span>
            {"\n"}
                <span className="qwerty-4" >&#123; </span>
            {"\n"}
                  <span className="qwerty-3"> statement</span>
                  <span className="qwerty-4">;</span>
                  {"\n"}
                <span className="qwerty-4" >&#125;</span>       
            {"\n"}          
                <span className="qwerty-6">else</span>
                {"\n"}
                <span className="qwerty-4" >&#123; </span>
            {"\n"}
                  <span className="qwerty-3"> statement</span>
                  <span className="qwerty-4">;</span>
                  {"\n"}
                <span className="qwerty-4" > &#125;</span>       
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div> 


<h2 className="mt-4 mh2">If else if is used more than two options
</h2>




<h2 className='headings'>Q-Write a program to check a no is Positive, Negative, or Zero?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}
                        <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
            {"\n"}
                 <span className="qwerty-4" >&#123; </span>
            {"\n"}
            <span className="qwerty-3">  int</span>
                <span className="qwerty-5"> i</span>
                -<span className="qwerty-4">;</span>
            {"\n"} 
            <span className="qwerty-8">  printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">Enter a no</span>
                <span className="qwerty-4">");</span>
            {"\n"}
             <span className="qwerty-6">  scanf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-3">%d</span>
            <span className="qwerty-4">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-5">i</span>
            <span className="qwerty-4">);</span>
       {"\n"}
                
                 <span className="qwerty-6">  if </span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-5">i</span>
                 <span className="qwerty">&#60;</span>
                 <span className="qwerty-1">0</span>
                 <span className="qwerty-4">) </span>
             {"\n"}
                 <span className="qwerty-4" >  &#123; </span>
             {"\n"}
             <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">negative</span>
                <span className="qwerty-4">");</span>
                                 {"\n"}
                 <span className="qwerty-4" >  &#125;</span>       
             {"\n"}            
                <span className="qwerty-6">  else if </span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-5">i</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-1">0</span>
                 <span className="qwerty-4">) </span>
             {"\n"}
                 <span className="qwerty-4" >  &#123; </span>
             {"\n"}
                <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">positive</span>
                <span className="qwerty-4">");</span>
                   {"\n"}
                 <span className="qwerty-4" >  &#125;</span>       
             {"\n"}          
                 <span className="qwerty-6">  else</span>
                 {"\n"}
                 <span className="qwerty-4" >  &#123; </span>
             {"\n"}
                <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">zero</span>
                <span className="qwerty-4">");</span>
                               {"\n"}
                 <span className="qwerty-4" >  &#125;</span>       
             {"\n"}
             <span className="qwerty-7">  return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
            {"\n"}
                 <span className="qwerty-4" >&#125;</span>       
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
                <code >                              
                            {"\n"}
                        <span className="qwerty-5">Enter a no </span>
                        <span className="qwerty-1">24 </span>
                            {"\n"}
                        <span className="qwerty-5">positive</span>
                            {"\n"}
                            {"\n"}
                </code>
                </pre>
                </div>  



<h2 className='headings'>Q-Write a program to input the age and print appropriate messages according to the complete condition?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}
                        <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
            {"\n"}
                 <span className="qwerty-4" >&#123; </span>
            {"\n"}
            <span className="qwerty-3">  int</span>
                <span className="qwerty-5"> age</span>
                -<span className="qwerty-4">;</span>
            {"\n"} 
            <span className="qwerty-8">  printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">Enter age</span>
                <span className="qwerty-4">");</span>
            {"\n"}
             <span className="qwerty-6">  scanf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-3">%d</span>
            <span className="qwerty-4">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-5">age</span>
            <span className="qwerty-4">);</span>
       {"\n"}                
                 <span className="qwerty-6">  if </span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-5">age</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty">=</span>
                 <span className="qwerty-1">60</span>
                 <span className="qwerty-4">) </span>
             {"\n"}
                 <span className="qwerty-4" >  &#123; </span>
             {"\n"}
             <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">old man</span>
                <span className="qwerty-4">");</span>
                                 {"\n"}
                 <span className="qwerty-4" >  &#125;</span>       
             {"\n"}            
                <span className="qwerty-6">  else if </span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-5">age</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-1">40</span>
                 <span className="qwerty-4">) </span>
             {"\n"}
                 <span className="qwerty-4" >  &#123; </span>
             {"\n"}
                <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">not old and not young</span>
                <span className="qwerty-4">");</span>
                   {"\n"}
                 <span className="qwerty-4" >  &#125;</span>       
             {"\n"}          
             {"\n"}            
                <span className="qwerty-6">  else if </span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-5">age</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-1">20</span>
                 <span className="qwerty-4">) </span>
             {"\n"}
                 <span className="qwerty-4" >  &#123; </span>
             {"\n"}
                <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">young age</span>
                <span className="qwerty-4">");</span>
                   {"\n"}
                 <span className="qwerty-4" >  &#125;</span>       
             {"\n"}          
                 <span className="qwerty-6">  else</span>
                 {"\n"}
                 <span className="qwerty-4" >  &#123; </span>
             {"\n"}
                <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">child</span>
                <span className="qwerty-4">");</span>
                               {"\n"}
                 <span className="qwerty-4" >  &#125;</span>       
             {"\n"}
             <span className="qwerty-7">  return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
            {"\n"}
                 <span className="qwerty-4" >&#125;</span>       
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
                <code >                              
                            {"\n"}
                        <span className="qwerty-5">Enter age </span>
                        <span className="qwerty-1">24 </span>
                            {"\n"}
                        <span className="qwerty-5">young age</span>
                            {"\n"}
                            {"\n"}
                </code>
                </pre>
                </div> 



<h2 className='headings'>Q-Write a program to find out the maximum within three numbers?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}
                        <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
            {"\n"}
                 <span className="qwerty-4" >&#123; </span>
            {"\n"}
            <span className="qwerty-3">  int</span>
                <span className="qwerty-5"> a</span>
                <span className="qwerty-4">,</span>
                <span className="qwerty-5">b</span>
                <span className="qwerty-4">,</span>
                <span className="qwerty-5">c</span>
                <span className="qwerty-4">;</span>
            {"\n"} 
            <span className="qwerty-8">  printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">Enter a value</span>
                <span className="qwerty-4">");</span>
            {"\n"}
             <span className="qwerty-6">  scanf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-3">%d</span>
            <span className="qwerty-4">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-4">);</span>
       {"\n"}
       <span className="qwerty-8">  printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">Enter b value</span>
                <span className="qwerty-4">");</span>
            {"\n"}
             <span className="qwerty-6">  scanf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-3">%d</span>
            <span className="qwerty-4">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-4">);</span>
       {"\n"}
               <span className="qwerty-8">  printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">Enter c value</span>
                <span className="qwerty-4">");</span>
            {"\n"}
             <span className="qwerty-6">  scanf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-3">%d</span>
            <span className="qwerty-4">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-5">c</span>
            <span className="qwerty-4">);</span>
       {"\n"}               
                 <span className="qwerty-6">  if </span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-5">a</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-5">b</span>
                 <span className="qwerty-3"> &amp;&amp; </span>
                 <span className="qwerty-5">a</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-5">c</span>
                 <span className="qwerty-4">) </span>
             {"\n"}
                 <span className="qwerty-4" >  &#123; </span>
             {"\n"}
             <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">maximum no is</span>
                <span className="qwerty-3"> %d</span>
                <span className="qwerty-4">",</span>
                <span className="qwerty-5">a</span>
                <span className="qwerty-4">);</span>
                                 {"\n"}
                 <span className="qwerty-4" >  &#125;</span>       
             {"\n"}            
                <span className="qwerty-6">  else if </span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-5">b</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-5">a</span>
                 <span className="qwerty-3"> &amp;&amp; </span>
                 <span className="qwerty-5">b</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-5">c</span>
                 <span className="qwerty-4">) </span>
             {"\n"}
                 <span className="qwerty-4" >  &#123; </span>
             {"\n"}
                <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">maximum no is</span>
                <span className="qwerty-3"> %d</span>
                <span className="qwerty-4">",</span>
                <span className="qwerty-5">b</span>
                  <span className="qwerty-4">);</span>
                   {"\n"}
                 <span className="qwerty-4" >  &#125;</span>       
             {"\n"}          
                 <span className="qwerty-6">  else</span>
                 {"\n"}
                 <span className="qwerty-4" >  &#123; </span>
             {"\n"}
                <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">maximum no is</span>
                <span className="qwerty-3"> %d</span>
                <span className="qwerty-3">",</span>
                <span className="qwerty-5">c</span>
                <span className="qwerty-4">");</span>
                               {"\n"}
                 <span className="qwerty-4" >  &#125;</span>       
             {"\n"}
             <span className="qwerty-7">  return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
            {"\n"}
                 <span className="qwerty-4" >&#125;</span>       
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
                <code >                              
                            {"\n"}
                        <span className="qwerty-5">Enter a value </span>
                        <span className="qwerty-1">2 </span>
                            {"\n"}
                        <span className="qwerty-5">Enter b value </span>
                        <span className="qwerty-1">8 </span>
                            {"\n"}
                        <span className="qwerty-5">Enter c value </span>
                        <span className="qwerty-1">4 </span>
                            {"\n"}
                        <span className="qwerty-3">maximum no is</span>
                        <span className="qwerty-4"> 8</span>
                            {"\n"}
                            {"\n"}
                </code>
                </pre>
                </div> 

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-switch">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cifelseif;